import 'css-chunksrc/client/pages/zonesPage/styles.scss';export default {
  "zonesPage": "_zonesPage_15z86_1",
  "content": "_content_15z86_9",
  "mainHeader": "_mainHeader_15z86_16",
  "addZoneButton": "_addZoneButton_15z86_24",
  "wrapper": "_wrapper_15z86_28",
  "zones": "_zones_15z86_1",
  "selectedZone": "_selectedZone_15z86_42",
  "zone": "_zone_15z86_1",
  "zoneMain": "_zoneMain_15z86_59",
  "zoneHeader": "_zoneHeader_15z86_67",
  "zoneHeading": "_zoneHeading_15z86_72",
  "zoneTitle": "_zoneTitle_15z86_82",
  "icon": "_icon_15z86_88",
  "projectsTransfer": "_projectsTransfer_15z86_94",
  "zoneRemovalPopup": "_zoneRemovalPopup_15z86_108",
  "main": "_main_15z86_16"
};